// extracted by mini-css-extract-plugin
module.exports = {"AwardsFeed":"styles_AwardsFeed__EWVhA","height":"styles_height__Q_HNu"};